import React, {useCallback, useContext, useEffect, useReducer, useState} from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import AlternateEmailTwoToneIcon from "@mui/icons-material/AlternateEmailTwoTone";
import BusinessTwoToneIcon from "@mui/icons-material/BusinessTwoTone";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";
import SaveTwoToneIcon from "@mui/icons-material/SaveTwoTone";
import {useForm} from "react-hook-form";
import {AppContext} from "../../../../App";
import {emailRegister, valueRegister} from "../../../../utils/RegisterUtils";
import {getCompany, updateCompany} from "../../../../services/ReferenteServices";
import {getCompanyInfo} from "../../../../utils/GenericUtils";
import {initReferenteState, REFERENTE_INITIAL_STATE, ReferenteReducer} from "../../../../reducers/ReferenteReducer";
import {setOpenSnackbar} from "../../../../services/AppServices";
import GoogleMaps from "../../../widgets/inputs/GoogleMapsInput";
import SolidTextField from "../../../widgets/inputs/SolidTextField";
import CompanyFieldSection from "./CompanyFieldSection";

const DatiAzienda = ({classes, idSoggetto}) => {
	const appContext = useContext(AppContext);
	const {handleSubmit, control, errors, reset, register, setValue} = useForm({mode: "onChange"});
	const [submit, setSubmit] = useState(false);
	const [submitGetCompany, setSubmitGetCompany] = useState(false);
	const [state, dispatch] = useReducer(ReferenteReducer, REFERENTE_INITIAL_STATE, initReferenteState);
	const [value1, setValue1] = useState(null);
	const [inputValue1, setInputValue1] = useState("");

	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateCompany({
			id: getCompanyInfo().id,
			referente: {
				idSoggetto,
			},
			...data,
		}, dispatch);
	}, [idSoggetto, dispatch]);

	useEffect(() => {
		register("indirizzo", {required: true});
	}, [register]);

	useEffect(() => {
		if (value1 !== null) {
			setValue("indirizzo", inputValue1);
		}
	}, [value1, inputValue1, setValue]);

	useEffect(() => {
		if (submit && !state.loadingUpdateCompany && state.errorUpdateCompany === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Dati aggiornati con successo!", appContext.dispatch);
		} else if (submit && !state.loadingUpdateCompany && state.errorUpdateCompany !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorUpdateCompany, appContext.dispatch);
		}
	}, [submit, appContext.dispatch, state.loadingUpdateCompany, state.errorUpdateCompany]);

	useEffect(() => {
		setSubmitGetCompany(true);
		getCompany(getCompanyInfo()?.id, dispatch);
	}, [dispatch]);

	useEffect(() => {
		if (submitGetCompany && !state.loadingGetCompany && state.errorGetCompany === "") {
			setSubmitGetCompany(false);
			reset(state.company);
			setInputValue1(state.company?.indirizzo);
			setValue1(state.company?.indirizzo);
		}
	}, [submitGetCompany, state.loadingGetCompany, state.errorGetCompany, state.company, reset]);

	return (
		<section className={classes.panel}>
			<header className={classes.panelHeader}>
				<div>
					<Typography className={classes.panelTitle}>Dati azienda</Typography>
					<Typography className={classes.panelSubtitle}>
						Aggiorna recapiti, nome pubblico e indirizzo della struttura.
					</Typography>
				</div>
			</header>

			<form onSubmit={handleSubmit(onSubmit)}>
				<div className={classes.sectionStack}>
					<CompanyFieldSection
						classes={classes}
						icon={<AlternateEmailTwoToneIcon fontSize="small"/>}
						subtitle="Numeri di contatto e casella principale."
						title="Recapiti"
					>
						<div className={classes.fieldGrid}>
							<SolidTextField
								control={control}
								rules={valueRegister}
								name="telefono1"
								label="Telefono 1"
								autoFocus={false}
								error={errors["telefono1"]}
								size="small"
							/>
							<SolidTextField
								control={control}
								rules={valueRegister}
								name="telefono2"
								label="Telefono 2"
								autoFocus={false}
								error={errors["telefono2"]}
								size="small"
							/>
							<div className={classes.fieldGridFull}>
								<SolidTextField
									control={control}
									rules={emailRegister}
									name="mail"
									label="Email"
									autoFocus={false}
									error={errors["mail"]}
									size="small"
								/>
							</div>
						</div>
					</CompanyFieldSection>

					<CompanyFieldSection
						classes={classes}
						icon={<BusinessTwoToneIcon fontSize="small"/>}
						subtitle="Nome visualizzato per questa azienda dentro Atlantis."
						title="Identità azienda"
					>
						<SolidTextField
							control={control}
							rules={valueRegister}
							name="nome"
							label="Nome dell'azienda"
							autoFocus={false}
							error={errors["nome"]}
							size="small"
						/>
					</CompanyFieldSection>

					<CompanyFieldSection
						classes={classes}
						icon={<LocationOnTwoToneIcon fontSize="small"/>}
						subtitle="Indirizzo operativo usato come riferimento aziendale."
						title="Sede"
					>
						<GoogleMaps
							value={value1}
							setValue={setValue1}
							inputValue={inputValue1}
							setInputValue={setInputValue1}
							label="Indirizzo dell'azienda"
							disabled={submit}
							size="small"
						/>
					</CompanyFieldSection>
					</div>

				<div className={classes.actionRow}>
					<Button
						className={classes.actionButton}
						disabled={submit}
						disableElevation
						onClick={handleSubmit(onSubmit)}
						size="small"
						startIcon={submit ? <CircularProgress size={16}/> : <SaveTwoToneIcon/>}
						type="submit"
						variant="contained"
					>
						Aggiorna dati
					</Button>
				</div>
			</form>
		</section>
	);
};

export default React.memo(DatiAzienda);
